require('./subscriptionLegalConfirmation.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
// @components
const BrokerLegalConfirmation = require('components/contactCenter/brokerLegalConfirmation/brokerLegalConfirmation');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
const { formatDate } = require('utilities/dateHelper');
// @constants
const prefix = 'subscriptionLegalConfirmation';
const { DATE_FORMAT_WITH_DASHES } = require('constants/index');

class SubscriptionLegalConfirmation extends React.Component {
    constructor(props) {
        super(props);

        this.handleYesNoOptionChange = this.handleYesNoOptionChange.bind(this);
    }

    handleYesNoOptionChange(value) {
        this.props.onYesNoOptionChange(value);
    }

    buildLegalDisclaimerDocumentLinks() {
        const { legalinformationLinks } = this.props;

        return (
            <div>
                <p>
                    <FormattedText
                        value={`${prefix}-legalDisclaimerDocumentsFirstStatement`}
                    />
                    <FormattedTextWithComponents
                        value={`${prefix}-legalDisclaimerDocumentsSecondStatement`}
                        injectedComponents={legalinformationLinks}
                    />
                </p>
            </div>
        );
    }

    buildLegalDisclaimerQuestion() {
        const { immProfileFields } = this.props;
        const clientName = PersonalDataHelper.getFullName(immProfileFields, false);

        return (
            <div>
                <p>
                    <FormattedText
                        value={`${prefix}-legalDisclaimerQuestionFirstStatement`}
                    />
                </p>
                <p>
                    <FormattedText
                        value={`${prefix}-legalDisclaimerQuestionSecondStatement`}
                        injectedStrings={[ clientName ]}
                    />
                </p>
            </div>
        );
    }

    buildLegalDisclaimerYesAnswer() {
        return (
            <div>
                <p><FormattedText value={`${prefix}-legalDisclaimerYesAnswerStatement`} /></p>
            </div>
        );
    }

    buildLegalDisclaimerNoAnswer() {
        return (
            <div>
                <p><FormattedText value={`${prefix}-legalDisclaimerNoAnswerFirstStatement`} /></p>
                <p><FormattedText value={`${prefix}-legalDisclaimerNoAnswerSecondStatement`} /></p>
            </div>
        );
    }

    buildLegalTextProductDescription() {
        const { immProfileFields, immCorporatesOperation, currency, exAnteCost } = this.props;
        const searchResultsNoData = formatText('broker-searchResultsNoData');

        const clientName = PersonalDataHelper.getFullName(immProfileFields, false);
        const {
            descriptionValue,
            proportion,
            startDate: startDateISO,
            nominalValue,
            payment,
            closeDate: closeDateISO,
            endDate: endDateISO,
        } = immCorporatesOperation.toJS();

        const startDate = startDateISO ? formatDate(startDateISO, DATE_FORMAT_WITH_DASHES) : null;
        const closeDate = closeDateISO ? formatDate(closeDateISO, DATE_FORMAT_WITH_DASHES) : null;
        const endDate = endDateISO ? formatDate(endDateISO, DATE_FORMAT_WITH_DASHES) : null;

        const [ proportionPart, proportionTotal ] = proportion ? proportion.toLowerCase().split('x') : [];

        let proportionKey = 'featureProportionPluralPluralBody';
        if ( parseInt(proportionPart) === 1 && parseInt(proportionTotal) > 1 ) {
            proportionKey = 'featureProportionSingularPluralBody';
        }
        if ( parseInt(proportionPart) === 1 && parseInt(proportionTotal) === 1 ) {
            proportionKey = 'featureProportionSingularSingularBody';
        }

        const featureDescription = descriptionValue ? formatText(`${prefix}-featureDescriptionBody`, [ descriptionValue ]) : searchResultsNoData;
        const featureProportion = proportionPart && proportionTotal ? formatText(`${prefix}-${proportionKey}`, [ proportionPart, proportionTotal ]) : searchResultsNoData;
        const featureNominalvalue = (nominalValue || nominalValue === 0) && currency ? formatText(`${prefix}-featureNominalValueBody`, [ nominalValue, currency ]) : searchResultsNoData;
        const featurePayment = payment ? formatText(`${prefix}-featurePaymentBody`, [ payment ]) : searchResultsNoData;
        const featurePaymentTime = startDate && closeDate ? formatText(`${prefix}-featurePaymentTimeBody`, [startDate, closeDate]) : searchResultsNoData;
        const featureLimitWithoutInstructions = endDate && startDate ? formatText(`${prefix}-featureLimitWithoutInstructionsBody`, [startDate, endDate]) : searchResultsNoData;
        const featureInterveners = formatText(`${prefix}-featureIntervenersBody`);
        const featureAlternativeMarket = formatText(`${prefix}-featureAlternativeMarketBody`);

        const buildFeature = (description, titleKey) => (<li>
            { !titleKey ? null : <strong>
                <FormattedText
                    value={`${prefix}-${titleKey}`}
                />
            </strong>}
            { description }
        </li>);

        return (
            <div>
                <p>
                    <FormattedText
                        value={`${prefix}-titleMainFeatures`}
                        injectedStrings={[clientName]}
                    />
                </p>
                <ul>
                    {buildFeature(featureDescription)}
                    {buildFeature(featureProportion, 'featureProportionTitle')}
                    {buildFeature(featureNominalvalue, 'featureNominalValueTitle')}
                    {buildFeature(featurePayment, 'featurePaymentTitle')}
                    {buildFeature(featurePaymentTime, 'featurePaymentTimeTitle')}
                    {buildFeature(featureLimitWithoutInstructions, 'featureLimitWithoutInstructionsTitle')}
                    {buildFeature(featureInterveners)}
                    {buildFeature(featureAlternativeMarket)}
                </ul>
                {exAnteCost}
            </div>
        );
    }

    buildBrokerLegalConfirmation() {
        const {
            immProfileFields,
            immPreContractualMail,
            sendMail,
            resetMailState,
            requestProfile,
            selectedYesNoOption,
            sendMailParams,
        } = this.props;

        const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
        const refreshEmailError = immProfileFields.get('error') ? immProfileFields.getIn([ 'error', 'description' ], 'Error') : undefined;

        return (
            <BrokerLegalConfirmation
                className="subscription-legal-confirmation__legal-confirmation no-print-out"
                legalDisclaimerQuestion={this.buildLegalDisclaimerQuestion()}
                legalDisclaimerYesAnswer={this.buildLegalDisclaimerYesAnswer()}
                legalDisclaimerNoAnswer={this.buildLegalDisclaimerNoAnswer()}
                legalDisclaimerProductDescription={this.buildLegalTextProductDescription()}
                legalDisclaimerDocumentLinks={this.buildLegalDisclaimerDocumentLinks()}
                onYesNoOptionChange={this.handleYesNoOptionChange}
                selectedYesNoOption={selectedYesNoOption}
                sendMail={sendMail}
                resetMailState={resetMailState}
                clientEmailAddress={clientEmail}
                refreshEmailAddress={requestProfile}
                immPreContractualMail={immPreContractualMail}
                refreshEmailAddressError={refreshEmailError}
                sendMailParams={sendMailParams}
            />
        );
    }

    render() {
        const { className } = this.props;
        const subscriptionLegalConfirmationClassNames = classNames('subscription-legal-confirmation', { [className]: !!className });

        return (
            <div className={subscriptionLegalConfirmationClassNames}>
                {this.buildBrokerLegalConfirmation()}
            </div>
        );
    }
}

SubscriptionLegalConfirmation.defaultProps = {
    exAnteCost: null,
}

SubscriptionLegalConfirmation.propTypes = {
    className: PropTypes.string,
    legalinformationLinks: PropTypes.array.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    sendMail: PropTypes.func.isRequired,
    sendMailParams: PropTypes.object.isRequired,
    resetMailState: PropTypes.func.isRequired,
    selectedYesNoOption: PropTypes.string.isRequired,
    requestProfile: PropTypes.func.isRequired,
    onYesNoOptionChange: PropTypes.func.isRequired,
    immCorporatesOperation: PropTypes.object.isRequired,
    currency: PropTypes.string,
    exAnteCost: PropTypes.any,
};

module.exports = SubscriptionLegalConfirmation;
